import { Button } from '@vtex/shoreline'

import icon from './icon.png'

import styles from './styles.module.css'

export const DefaultErrorFallback: FallbackComponent = ({
  reset,
  code,
  description,
  title,
  tryAgainLabel,
  errorLabel,
  fullScreen = true
}) => (
  <div
    className={`${styles.defaultErrorFallback} ${fullScreen && styles.fullScreen}`}
  >
    <div className={styles.megaphoneIcon}>
      <img src={icon} alt="Imagem de um megafone." width="152" height="144" />
    </div>
    <h1 className={styles.title}>{title || 'Oops!'}</h1>
    <div className={styles.textWrapper}>
      <p className={styles.description}>
        {description || 'Algo deu errado. Já estamos resolvendo.'}
      </p>
      {!!code && (
        <span className={styles.errorCode}>
          {errorLabel || 'Erro:'} {code}
        </span>
      )}
    </div>
    {!!reset && (
      <Button
        onClick={() => {
          reset(true)
        }}
      >
        {tryAgainLabel || 'Tentar novamente'}
      </Button>
    )}
  </div>
)
